import type {
  TransactionGroup,
  UserBalance,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import { formatTimestamp } from "../../../libs/date";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";
import { Cell } from "./cell";

type TransferInTransactionDetailProps = {
  transactionGroup: TransactionGroup;
  balances: UserBalance[];
};

export function TransferInTransactionDetail({
  transactionGroup,
  balances,
}: TransferInTransactionDetailProps) {
  const summaryDetail = transactionGroup.transactionDetails[0];
  const amount = transactionGroup.transactionDetails.reduce(
    (acc: number, ts) => acc + Number(ts.transaction?.amount || 0),
    0,
  );

  // ポイントの対象情報（資金源名）を取得
  const pointSource = summaryDetail.fundSource?.name || t("不明");
  // transfer_inは必ず1つのbalanceのみ存在する
  const expireAt = balances.length > 0 ? (balances[0].expireAt ?? null) : null;

  return (
    <div
      className={css({
        bg: "white",
        px: "16px",
        rounded: "16px",
      })}
    >
      <Cell label={t("取引種別")} value={t("ポイント譲渡（受け取り）")} />
      <Cell label={t("受け取りポイント")} value={`${formatNumber(amount)}pt`} />
      <Cell label={t("ポイント種類")} value={pointSource} />
      {expireAt && (
        <Cell label={t("有効期限")} value={formatTimestamp(expireAt)} />
      )}
      <Cell
        label={t("受取日時")}
        value={formatTimestamp(summaryDetail.transaction?.createdAt)}
      />
      <Cell label="ID" value={transactionGroup.id} lastChild={true} />
    </div>
  );
}
